// @flow
import constants from "./CONSTANTS";

const actions = {
  setRefreshingToken: (isTokenRefreshing) => ({
    type: constants.SET_REFRESHING_TOKEN,
    isTokenRefreshing,
  }),
  setRefreshingTokenFailed: (tokenRefreshingFailed) => ({
    type: constants.SET_REFRESHING_TOKEN_FAILED,
    tokenRefreshingFailed,
  }),
  resetAll: () => ({
    type: constants.RESET_ALL,
  }),
  loginRequest: (pId, password, rememberMe) => ({
    type: constants.LOGIN_REQ,
    pId,
    password,
    rememberMe
  }),
  changeUserPassword: ({ oldPassword, newPassword }) => ({
    type: constants.CHANGE_USER_PASSWORD,
    oldPassword,
    newPassword,
  }),
  loginSuccess: (user) => ({
    type: constants.LOGIN_SUCCESS,
    value: user,
  }),
  loginFail: (error) => ({ type: constants.LOGIN_FAIL, error }),
  setUser: (user) => ({ type: constants.SET_USER, user }),
  setSession: (session) => ({
    type: constants.SET_SESSION,
    session,
  }),
  logoutUser: () => ({ type: constants.LOGOUT_USER }),
  loading: (loadingState) => ({
    type: constants.SET_LOADING,
    loadingState,
  }),
  refreshSession: (onSuccess) => ({
    type: constants.REFRESH_SESSION,
    onSuccess,
  }),
  checkSession: () => ({
    type: constants.CHECK_SESSION,
  }),
  userMustChangePassword: (mustChangePassword) => ({
    type: constants.USER_MUST_CHANGE_PASSWORD,
    mustChangePassword,
  }),

  getApprovalsExpirationStatus: () => ({
    type: constants.GET_APPROVAL_EXPIRATION_STATUS,
  }),
  setApprovalsExpirationStatus: (payload) => ({
    type: constants.SET_APPROVAL_EXPIRATION_STATUS,
    payload,
  }),
  getLoginSendOTP: (payload) => ({
    type: constants.GET_MAIN_LOGIN_SEND_OTP,
    payload,
  }),
  setLoginSendOTP: (payload) => ({
    type: constants.SET_MAIN_LOGIN_SEND_OTP,
    payload,
  }),
  getCheckuser: (payload) => ({
    type: constants.GET_MAIN_CHECK_USER,
    payload,
  }),
  setCheckuser: (payload) => ({
    type: constants.SET_MAIN_CHECK_USER,
    payload,
  }),
  getRegisterUser: (payload) => ({
    type: constants.GET_MAIN_REGISTER_USER,
    payload,
  }),
  setRegisterUser: (payload) => ({
    type: constants.SET_MAIN_REGISTER_USER,
    payload,
  }),

  getLoginwithcode: (payload) => ({
    type: constants.GET_MAIN_LOGIN_WITH_CODE,
    payload,
  }),
  setLoginwithcode: (payload) => ({
    type: constants.SET_MAIN_LOGIN_WITH_CODE,
    payload,
  }),

  getValidateotp: (payload) => ({
    type: constants.GET_MAIN_VALIDATE_OTP,
    payload,
  }),
  setValidateotp: (payload) => ({
    type: constants.SET_MAIN_VALIDATE_OTP,
    payload,
  }),

  getRecoverpassword: (payload) => ({
    type: constants.GET_MAIN_RECOVER_PASSWORD,
    payload,
  }),
  setRecoverpassword: (payload) => ({
    type: constants.SET_MAIN_RECOVER_PASSWORD,
    payload,
  }),

  getStartidentomat: (payload) => ({
    type: constants.GET_MAIN_START_IDENTOMAT,
    payload,
  }),
  setStartidentomat: (payload) => ({
    type: constants.SET_MAIN_START_IDENTOMAT,
    payload,
  }),

  getValidateidentomat: (payload) => ({
    type: constants.GET_MAIN_VALIDATE_IDENTOMAT,
    payload,
  }),
  setValidateidentomat: (payload) => ({
    type: constants.SET_MAIN_VALIDATE_IDENTOMAT,
    payload,
  }),


  getValidateInsurer: (payload) => ({
    type: constants.GET_VALIDATE_INSURER,
    payload,
  }),
  setValidateInsurer: (payload) => ({
    type: constants.SET_VALIDATE_INSURER,
    payload,
  }),


  getSendotptomobile: (payload) => ({
    type: constants.GET_MAIN_SNED_OTP_TO_MOBILE,
    payload,
  }),
  setSendotptomobile: (payload) => ({
    type: constants.SET_MAIN_SNED_OTP_TO_MOBILE,
    payload,
  }),

  getChangemobile: (payload) => ({
    type: constants.GET_MAIN_CHANGE_MOBILE,
    payload,
  }),
  setChangemobile: (payload) => ({
    type: constants.SET_MAIN_CHANGE_MOBILE,
    payload,
  }),
  setLoginRequest: (payload) => ({
    type: constants.SET_LOGIN_REQ,
    payload,
  }),
  getIsIdentomat: (payload) => ({
    type: constants.GET_MAIN_TO_IDENTOMAT,
    payload,
  }),
  setIsIdentomat: (payload) => ({
    type: constants.SET_MAIN_TO_IDENTOMAT,
    payload,
  }),
};

export default actions;
